import { createRouter, createWebHistory } from "vue-router";
import UnauthorizedPage from "@/views/UnauthorizedPage.vue";

const routes = [
  {
    path: "/",
    name: "UnauthorizedPage",
    component: UnauthorizedPage,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
